export const OrganizationParametersGeneration = organizationData => {
  const options = new URLSearchParams()
  options.append('name', organizationData.name)
  options.append('zoho_prefix', organizationData.zoho_prefix)
  options.append('slug', organizationData.slug ?? '')
  if (organizationData.zoho_potential_net_status) {
    options.append('zoho_potential_net_status', organizationData.zoho_potential_net_status)
  }

  return options
}
